if (!customElements.get('slideshow-component')) {
  customElements.define('slideshow-component', class SlideshowComponent extends HTMLElement {
    constructor() {
      super();
      this.slider = this.querySelector('.slider');
      this.slides = Array.from(this.querySelectorAll('.slider__slide'));
      this.prevButton = this.querySelector('button[name="previous"]');
      this.nextButton = this.querySelector('button[name="next"]');
      
      if (!this.slider || this.slides.length <= 1) return;

      this.autoplay = this.slider.dataset.autoplay === 'true';
      this.speed = parseInt(this.slider.dataset.speed) * 1000 || 5000;
      this.index = 0;

      this.init();
    }

    init() {
      // Buttons click events
      this.prevButton.addEventListener('click', () => {
        this.stopAutoplay();
        this.move('prev');
        if (this.autoplay) this.startAutoplay();
      });

      this.nextButton.addEventListener('click', () => {
        this.stopAutoplay();
        this.move('next');
        if (this.autoplay) this.startAutoplay();
      });

      // Start Auto
      if (this.autoplay) this.startAutoplay();
      
      // Initial state
      this.updateSlider();
    }

    move(direction) {
      const totalSlides = this.slides.length;
      if (direction === 'next') {
        this.index = (this.index + 1) % totalSlides;
      } else {
        this.index = (this.index - 1 + totalSlides) % totalSlides;
      }
      this.updateSlider();
    }

    updateSlider() {
      const offset = -(this.index * 100);
      this.slides.forEach(slide => {
        slide.style.transform = `translateX(${offset}%)`;
        slide.style.transition = 'transform 0.5s ease-out';
      });
    }

    startAutoplay() {
      this.autoplayTimer = setInterval(() => this.move('next'), this.speed);
    }

    stopAutoplay() {
      clearInterval(this.autoplayTimer);
    }
  });
}